<template>
  <div class="add-new-user">
    <form @submit.prevent="addEula">
      <table class="table table-create">
        <thead>
          <tr>
            <th
              colspan="4"
              class="text-center"
            >
              <h3>Add new eula</h3>
            </th>
          </tr>
        </thead>
        <tr>
          <th>Name</th>
          <td>
            <input
              v-validate="'required|' + $formValidator.rules.eula_name"
              v-model="eula.name"
              :error-messages="errors.collect('eula_name')"
              :class="{
                'form-control': true,
                'is-invalid': errors.has('eula_name')
              }"
              data-vv-name="eula_name"
              type="text"
              class="form-control"
            >
            <div :class="{ 'validation-feedback': true, 'invalid-feedback': errors.has('eula_name') }">
              {{ errors.first('eula_name') }}
            </div>
          </td>
        </tr>
        <tr>
          <th>Main text (de)</th>
          <td>
            <input
              v-model="eula.text_base_de"
              type="html"
              class="form-control"
              data-vv-name="text_base_de"
              placeholder="Main text in german">
          </td>
        </tr>
        <tr>
          <th>Main text (en)</th>
          <td>
            <input
              v-model="eula.text_base_en"
              type="html"
              class="form-control"
              data-vv-name="text_base_de"
              placeholder="Main text in english">
          </td>
        </tr>
        <tr>
          <td class="text-right">
            <input
              :disabled="saving || !!errors.items.length"
              type="submit"
              value="Create"
              class="btn btn-info">
          </td>
        </tr>
      </table>
    </form>

    <eulas-list
      :user_id="this.$auth.user.id"
      :key="componentKey"/>
  </div>

</template>

<script>
import { vp } from '@/tools/helpers'
import EulasList from './EulasList.vue'

export default {
  name: 'Eula',
  components: {
    EulasList
  },
  data () {
    return {
      saving: false,
      componentKey: 0,
      eula: {
        name: null,
        text_base_de: null,
        text_base_en: null,
        add_paragraph_de: null,
        add_paragraph_en: null
      }
    }
  },
  computed: {},
  methods: {
    forceRerender () {
      this.componentKey += 1
    },
    async addEula (event) {
      try {
        this.saving = true
        console.log(this.eula)
        await this.$post('/eula/create', this.eula)
      } catch (err) {
        console.log('create task error::', err)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style>
.table-create-user {
  background-color: #f0f6f7;
}

.table-create th {
  background-color: #f0f6f7;
}
.table-create thead th {
  background-color: rgb(254, 255, 246);
}
</style>
